import { render, staticRenderFns } from "./Detail-sold-items.vue?vue&type=template&id=671c2f45"
import script from "./Detail-sold-items.vue?vue&type=script&lang=js"
export * from "./Detail-sold-items.vue?vue&type=script&lang=js"
import style0 from "./Detail-sold-items.vue?vue&type=style&index=0&id=671c2f45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports